export default __webpack_public_path__ + "static/media/Frame8.97afd8fa.png";